'use es6';

import { createSelector } from 'reselect';
import { getThreadHistory } from '../../thread-histories/selectors/getThreadHistory';
import { getNumSoftDeletedMessages as getNumSoftDeletedMessagesFromHistory } from 'conversations-message-history/thread-history/operators/getters';
export const getNumSoftDeletedMessages = createSelector([getThreadHistory], getNumSoftDeletedMessagesFromHistory);